export default __webpack_public_path__ + "static/media/location.502ebd14.png";